import { __extends } from "tslib";
import { ValueObject } from '../../base/ddd-types/value-object';
/**
 * 当前文档的高级权限设置
 */
var DocAdvancedPrivilege = /** @class */ (function (_super) {
    __extends(DocAdvancedPrivilege, _super);
    function DocAdvancedPrivilege(jsonObj) {
        var _this = _super.call(this) || this;
        _this.readerCanComment = false;
        _this.viewForbidCopyPrint = false;
        _this.writerCanComment = false;
        _this.showCollaboratorList = false;
        _this.showViewingMembers = false;
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    return DocAdvancedPrivilege;
}(ValueObject));
export { DocAdvancedPrivilege };
